import { render, staticRenderFns } from "./WDDashboardAllLeadsStatus.vue?vue&type=template&id=4b9785f4&scoped=true&"
import script from "./WDDashboardAllLeadsStatus.vue?vue&type=script&lang=js&"
export * from "./WDDashboardAllLeadsStatus.vue?vue&type=script&lang=js&"
import style0 from "./WDDashboardAllLeadsStatus.vue?vue&type=style&index=0&id=4b9785f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9785f4",
  null
  
)

export default component.exports